

const data = {
  products: [
    {
      id: '1',
      name: 'Washing Machine',
      price: 150,
      image: "/images/washing-machine.jpeg",
      description: "it is well mainted washing machine having capacity of washing 10kg cloths ata a time.Eliminate stains without pre-treatment using Steam Wash.Finish a full load in 28 minutes using the Super Speed feature. Remotely control & monitor via SmartThings app"
    },
    {
      id: '2',
      name: 'Fridge',
      price: 50,
      image: "/images/friedge.jpeg",
      description: "it is 36inch Capacity Thru Door Ice DispenserExterior Water DispenserLED LightingFingerprint ResistantStainless Steel colour mainted washing machine having capacity of washing 10kg cloths ata a time."
    },
    {
      id: '3',
      name: 'Accessories',
      price: 40,
      image: "/images/accessories.jpg",
      description: "it is multi purpose. It is very easy to use and light weighted. INCLUDES: (1) DCF887 cordless impact driver, (1) DCD791 cordless drill/driver, (1) DCS367 cordless reciprocating saw, (1) DCL040 cordless work light, (1) DCS570 cordless circular saw and (1) DCS355 oscillating multi tool"
    },
    {
      id: '4',
      name: 'Gardening Machine',
      price: 70,
      image: "/images/gardeningmchine.jpeg",
      description: "it is well mainted washing machine.Our mowers make yard work a breeze. With easy-to-use attachments, effortless steering, and intuitive controls, enjoying the perfect lawn can happen all year round."
    },
    {
      id: '5',
      name: 'Play Station 5',
      price: 150,
      image: "/images/playstation.webp",
      description: "Unveil new gaming possibilities above your greatest imagination with the PlayStation 5 console.  Discover its lightning-fast loading times with an ultra-high speed SSD, deeper immersion with support for haptic feedback, adaptive triggers and 3D Audio. The new generation of gaming also comes with 4K, 8K output, and as usual; an all-new generation of incredible PlayStation Games. Your games graphics have never been as stunning! is well mainted washing machine. "
    },
    {
      id: '6',
      name: 'Blower',
      price: 650,
      image: "/images/blower.jpeg",
      description: "it is well mainted 7 amp motor provides a powerful and efficient blowing performance. Moves up to 180 CFM for fast and easy cleanup of leaves and debris. Built-In cord retention prevents frustrating interruptions during cleanup.Lightweight at only 4.7 lbs. Item does not include a cord, Up to 180MPH/180CFM for fast and easy cleanup of leaves and debris machine having capacity of washing 10kg cloths ata a time."
    },
  ],
};
export default data;
